import { Header16, Header24, Header32, Header40, Paragraph16 } from '../styles/typography'
import { SimpleLink } from '../components/atoms/link'
import styled from '@emotion/styled'
import { BlueButton, OrangeButton } from '../components/atoms/button'
import ResumeDoc from '../assets/files/Resume_EdraPrasetio.pdf'
import topLeftImg from '../assets/images/topLeftImgLarge.svg'
import bottomRightImg from '../assets/images/hopspan_screenshot1.1.png'
import { Footer } from '../components/atoms/footer'
import { Testimonials } from '../sections/Testimonials'
import { NavBar } from '../components/atoms/header'
import { Background, HeroBackground, HeroMainHeader, ImageWrapper } from '../components/atoms/pageHero'
import heroImage from '../assets/images/testimonial-image.jpg'
import { Contact } from '../sections/Contact'
import whiteLine from '../assets/images/vertical-line.png'
import { useEffect } from 'react'

export function Temp() {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])
    return (
        <div>
            <NavBar />
            <HeroBackground>
                <HeroMainHeader>
                    <div style={{ display: 'flex', flexDirection: 'row', gap: '32px', alignItems: 'center' }}>
                        <img src={whiteLine} style={{ height: '40px' }} />
                        <Header40 style={{ color: '#ffffff' }}>COMING SOON</Header40>
                    </div>
                </HeroMainHeader>
                <ImageWrapper src={heroImage} />
            </HeroBackground>

            <Background>
                <Header40>Page is still in development</Header40>
            </Background>

            <Testimonials />
            <Contact />
            <Footer />
        </div>
    )
}
